module.exports = __webpack_public_path__ + "static/media/awards_9.86004f0c.jpg";